<template>
  <div :style="rootElementStyle" class="wh-space-bottom">

    <b-card v-show="showStat">
      <slot name="stat"></slot>
    </b-card>

    <b-card v-show="showSearch">
      <slot name="search"></slot>
    </b-card>

    <b-card v-if="!nonCardContent">
      <slot></slot>
    </b-card>
    <slot v-else />

  </div>
</template>

<script>
import {
  BRow, BCol, BCard
} from 'bootstrap-vue'

export default {
  name: "PageContent",
  components: {
    BRow,
    BCol,
    BCard,
  },
  props: {
    showSearch: {type: Boolean, default: false},
    showStat: {type: Boolean, default: false},
    rootElementStyle: {type: String, default: ''},
    nonCardContent: {type: Boolean, default: false}, // If to use b-card as the content component
  }
}
</script>

<style scoped>

</style>
